<template>
  <header class="page-header">
    <div class="page-header__container">
      <slot name="left"></slot>
      <WTitle size="small">
        {{ title }}
      </WTitle>
    </div>
    <slot name="right"></slot>
  </header>
</template>
<script>
import { WTitle } from '@alice-health/wonderland-vue'

export default {
  components: { WTitle },
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__container {
    display: flex;
    align-items: center;
    gap: var(--gl-spacing-04);
  }
}
</style>
